const ClassNamePassthrough = ({
  children,
  className
}) => children(className);
var ClassNamePassthrough$1 = ClassNamePassthrough;

export { ClassNamePassthrough$1 as C };
//# sourceMappingURL=ClassNamePassthrough-6da34a78-bc7ff70a.js.map
